export default __webpack_public_path__ + "static/media/portfolio-unselected.2aaa1494.png";